import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from '@scalefast/components/modal';
import { ContentfulArticleContent } from 'src/app/core/interfaces/Contentful/Article/ContentfulArticleContent';
import { ContentfulArticleShareContent } from 'src/app/core/interfaces/Contentful/ArticleShareContent/ContentfulArticleShareContent';
import { ContentfulSectionContent } from 'src/app/core/interfaces/Contentful/ContentfulSectionContent';

@Component({
  selector: 'app-contentful-share-article',
  templateUrl: './contentful-share-article.component.html',
  styleUrls: ['./contentful-share-article.component.scss'],
  standalone: true,
  imports: [ModalComponent],
})
export class AppContentfulShareArticleComponent implements OnInit {
  @Input() contentfulSectionContent: ContentfulSectionContent | undefined;
  @ViewChild(ModalComponent) modalComponent: ModalComponent = new ModalComponent();

  articleShareContent: ContentfulArticleShareContent | undefined;
  hasFacebook: boolean | undefined;
  hasTwitter: boolean | undefined;
  facebookClicked: boolean = false;
  twitterClicked: boolean = false;

  ngOnInit() {
    if (this.contentfulSectionContent) {
      // @TODO: Check how we can differ the different contentful content types without using this any
      const contentfulSectionContent = this.contentfulSectionContent.contentfulContent?.content as ContentfulArticleContent;
      if (contentfulSectionContent && contentfulSectionContent.overview) {
        this.articleShareContent = contentfulSectionContent.articleShareContent;
        this.hasFacebook = contentfulSectionContent.articleShareContent?.hasFacebook;
        this.hasTwitter = contentfulSectionContent.articleShareContent?.hasTwitter;
      }
    }
  }

  openModal(platform: string): void {
    this.facebookClicked = false;
    this.twitterClicked = false;

    if (platform === 'facebook') {
      this.facebookClicked = true;
    }

    if (platform === 'twitter') {
      this.twitterClicked = true;
    }

    this.modalComponent.show();
  }

  /**
   * We open the links in a new tab as that's the way it is done in Oral B.
   * Also, it is safe to do this interactions with windows (it could cause problems with SSR using it)
   * as this is happening just after the user interacts with the buttons
   */
  share(): void {
    const currentUrl: string = window.location.href;

    if (this.facebookClicked) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + currentUrl, '_blank');
    }

    if (this.twitterClicked) {
      window.open('https://twitter.com/intent/tweet?text=&amp;url=' + currentUrl, '_blank');
    }
  }
}
